import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable, ingresarCPASinCupoTodos, ingresarCPASinCupoPorCereal } from '../actions/TablaCamionesSinCupoActions'
import TablaCamionesSinCupoView from '../components/TablaCamionesSinCupoView'
import { ToastContainer } from 'react-toastify'
import SinCupoIngresarPorCereal from '../components/SinCupoIngresarPorCereal'
import SinCupoIngresarTodos from '../components/SinCupoIngresarTodos'

function TablaCamionesSinCupo (props) {
  const { filtroInicial = null, actualizarDatosParaMuiTable, roles } = props
  const [cerealFiltrado, setCerealFiltrado] = useState(null)
  const [cerealFiltradoNombre, setCerealFiltradoNombre] = useState(null)

  useEffect(() => {
    actualizarDatosParaMuiTable(filtroInicial)

    if (filtroInicial && filtroInicial.length > 0 && filtroInicial[0].filterList.length > 0) {
      const filtroCereal = filtroInicial.filter((f) => f.name === 'cereal')
      if (filtroCereal && filtroCereal.length > 0) {
        const cerealNombre = (filtroCereal[0].filterList[0])
        setCerealFiltradoNombre(cerealNombre)
      } else {
        setCerealFiltrado(null)
      }
    }
  }, [actualizarDatosParaMuiTable, filtroInicial, setCerealFiltradoNombre])

  const ingresarTodos = () => {
    props.ingresarCPASinCupoTodos()
  }

  const ingresarPorCereal = () => {
    props.ingresarCPASinCupoPorCereal(cerealFiltrado, filtroInicial)
  }

  const rolesAutorizantes = roles && roles.filter(rol => (rol === 'SUPERVISOR' || rol === 'DESARROLLADOR'))
  const rolAutoriza = rolesAutorizantes && rolesAutorizantes.length > 0

  return (
    <>
      <ToastContainer />
      {rolAutoriza &&
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          {cerealFiltrado
            ? <SinCupoIngresarPorCereal
              ingresarPorCereal={ingresarPorCereal}
              cerealFiltradoNombre={cerealFiltradoNombre}
            />
            : <SinCupoIngresarTodos
              ingresarTodos={ingresarTodos}
            />
          }
        </div>
      }
      <TablaCamionesSinCupoView />
    </>
  )
}

const mapStateToProps = (state) => ({
  roles: state.auth.roles
})

const mapActionsToProps = {
  actualizarDatosParaMuiTable,
  ingresarCPASinCupoTodos,
  ingresarCPASinCupoPorCereal
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(TablaCamionesSinCupo)
